var DropCountDown = class extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        var date_end = this.dataset.endDate;

        const parts = date_end.split(/[- :]/);

        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Mese indicizzato da 0
        const day = parseInt(parts[2], 10);
        const hours = parseInt(parts[3], 10);
        const minutes = parseInt(parts[4], 10);

        const dateObjectManual = new Date(year, month, day, hours, minutes);

        if (!isNaN(dateObjectManual.getTime())) {
            var countDownDate = dateObjectManual.getTime();
            var now = new Date().getTime();
            this.distance = countDownDate - now;
            this.setDateString();

            /**
             * Recursively calls itself every 1000ms (1s) and updates `this.distance` by subtracting 1000ms, 
             * then calls `this.setDateString()` to update the displayed date string.
             * This function is used to create a countdown timer.
             */
            const updateCountdown = () => {
                this.distance = this.distance - 1000;
                this.setDateString();
                setTimeout(updateCountdown, 1000);
            };
            setTimeout(updateCountdown, 1000);
        }
    }

    setDateString() {
        var days = ~~(this.distance / (1000 * 60 * 60 * 24));
        var hours = ~~((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = ~~((this.distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = ~~((this.distance % (1000 * 60)) / 1000);

        var time_string = '';
        if (days > 0) {
            time_string += days + 'd ';
        }

        if (hours > 0) {
            time_string += hours + 'h ';
        }

        if (minutes > 0) {
            time_string += minutes + 'm ';
        }

        time_string += seconds + 's';

        this.innerHTML = time_string;
    }

}
customElements.define("drop-countdown", DropCountDown);
